module.exports = __webpack_public_path__ + "static/img/bcg_k.78983b7e.png";